import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const InAppClick = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 24" {...props}>
    <path
      d="M19.3201 9.18994V4.68994C19.3201 4.39157 19.2015 4.10542 18.9906 3.89445C18.7796 3.68347 18.4934 3.56494 18.1951 3.56494H4.69507C4.3967 3.56494 4.11055 3.68347 3.89957 3.89445C3.68859 4.10542 3.57007 4.39157 3.57007 4.68994V17.0649C3.57007 17.3633 3.68859 17.6495 3.89957 17.8604C4.11055 18.0714 4.3967 18.1899 4.69507 18.1899H9.19507"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.902 11.6762L12.912 18.3744C12.9429 18.4777 13.0001 18.5711 13.0779 18.6456C13.1557 18.7201 13.2515 18.7731 13.356 18.7995C13.4604 18.8259 13.57 18.8247 13.6738 18.7961C13.7777 18.7675 13.8723 18.7124 13.9485 18.6362L14.9723 17.6124L17.6138 20.2539C17.6716 20.3118 17.7402 20.3576 17.8158 20.3889C17.8913 20.4202 17.9723 20.4363 18.054 20.4363C18.1358 20.4363 18.2168 20.4202 18.2923 20.3889C18.3678 20.3576 18.4365 20.3118 18.4943 20.2539L20.2553 18.4929C20.3131 18.4351 20.359 18.3665 20.3903 18.291C20.4216 18.2154 20.4377 18.1345 20.4377 18.0527C20.4377 17.9709 20.4216 17.89 20.3903 17.8144C20.359 17.7389 20.3131 17.6702 20.2553 17.6124L17.6138 14.9709L18.6375 13.9502C18.7137 13.8741 18.7688 13.7794 18.7975 13.6756C18.8262 13.5718 18.8274 13.4623 18.8011 13.3579C18.7748 13.2534 18.7219 13.1576 18.6475 13.0797C18.573 13.0019 18.4797 12.9447 18.3765 12.9137L11.6775 10.9037C11.5701 10.8718 11.4561 10.8695 11.3475 10.8969C11.2389 10.9244 11.1397 10.9806 11.0604 11.0596C10.981 11.1387 10.9244 11.2377 10.8965 11.3462C10.8687 11.4547 10.8706 11.5687 10.902 11.6762V11.6762Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.57007 6.93994H19.3201"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
